import { gql } from '@apollo/client';

const ADD_OBSERVATION_REPORT_DOCUMENT = gql`
  mutation AddObservationReportDocument($observationReport: ObservationReportInput!) {
    addObservationReport(observationReport: $observationReport)
  }
`;

export default ADD_OBSERVATION_REPORT_DOCUMENT;
